<template>
  <div ref="root" @wheel="handleWheel" @mousedown="startDrag">
    <div class="map" :style="style">
      <slot v-if="coordinate" />
    </div>
  </div>
</template>

<script>
import { createCoordinate } from './coord';
export default {
  props: {
    map: { type: String, required: true },
    zoomMax: { type: Number, default: 2 },
    zoomMin: { type: Number, default: 0.1 },
  },
  data() {
    return {
      clientWidth: 0,
      clientHeight: 0,
      scale: 1,
      offsetX: 0,
      offsetY: 0,
    };
  },
  provide() {
    return {
      getCoordinate: () => {
        return this.coordinate;
      },
    };
  },
  computed: {
    coordinate() {
      if (!this.clientWidth || !this.clientHeight) return null;

      return createCoordinate(
        {
          clientWidth: this.clientWidth * this.scale,
          clientHeight: this.clientHeight * this.scale,
        },
        {
          type: 'LB',
          xAxis: {
            min: 106.46586648000005,
            max: 106.657844,
          },
          yAxis: {
            min: 28.772276,
            max: 28.937259,
          },
        }
      );
    },
    style() {
      return {
        backgroundImage: `url(${this.map})`,
        transform: `translate(${(-this.clientWidth * (this.scale - 1)) / 2 + this.offsetX}px, ${
          (-this.clientHeight * (this.scale - 1)) / 2 + this.offsetY
        }px)`,
        width: this.clientWidth * this.scale + 'px',
        height: this.clientHeight * this.scale + 'px',
      };
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.clientWidth = this.$refs.root.clientWidth;
      this.clientHeight = this.$refs.root.clientHeight;
    },
    handleWheel(event) {
      event.preventDefault();
      this.scale = Math.min(this.zoomMax, Math.max(this.zoomMin, this.scale * (event.deltaY < 0 ? 1.1 : 0.9)));
    },

    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX - this.offsetX;
      this.startY = event.clientY - this.offsetY;
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },

    onDrag(event) {
      if (!this.isDragging) return;
      this.offsetX = event.clientX - this.startX;
      this.offsetY = event.clientY - this.startY;
    },

    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  },
};
</script>

<style scoped>
.map {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 100% 100%;
}
</style>
